import { TimelineMax } from 'gsap';
import {state} from './state';
// import {wheel} from './wheel';

let whaleSceneSet = {
  // duration:1.1,
  // ease:"Expo.easeOut",
  fadeTl: new TimelineMax(),
  whaleDom: [
    $(".w-whale01"),
    $(".w-whale02"),
    $(".w-whale03")
  ],
  measure:[{ 0: 8, 1: 13, 2: 19 }],
  whaleScale: $('.w-whaleScale'),
  whaleItem: $('.w-whale'),
  whaleType: $('.w-whaleType'),
  interval: 600,
  whaleTypeTrans: false,
  active: "is-active",
};

export const whalehandle={
  // mousewheelevent: 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll',
  // mouseWheelEvt: () => {
  //   try{ document.addEventListener(whalehandle.mousewheelevent, whalehandle.onWheel, { passive: false }); }
  //   catch(e){ document.attachEvent("onmousewheel", whalehandle.onWheel); }
  // },
  // noMouseWheelEvt:() =>{
  //   try{ document.removeEventListener(whalehandle.mousewheelevent, whalehandle.onWheel, { passive: false }); }
  //   catch(e){ document.detachEvent("onmousewheel", whalehandle.onWheel); }
  // },
  // onWheel: (e) => {

  //   if (!e) { e=window.event; }

  //   let delta = e.deltaY ? -(e.deltaY) : e.wheelDelta ? e.wheelDelta : -(e.detail);
  //   if (delta <= -1){ //下にスクロールした場合の処理
  //     e.preventDefault();
  //     whalehandle.noMouseWheelEvt();
  //     if (state.isMenu){
  //       if (state.whaleSceneCurrentID==2){
  //         wheel.mouseWheelEvt();
  //       }
  //       else {
  //         whaleSceneSet.whaleTypeTrans=true;
  //         state.whaleSceneCurrentID=Math.min(state.whaleSceneCurrentID+1, 2);
  //         whalehandle.next();
  //         whalehandle.currentHandle(state.whaleSceneCurrentID);
  //       }
  //     }
  //   }
  //   else if (delta >= 1){ //上にスクロールした場合の処理
  //     e.preventDefault();
  //     whalehandle.noMouseWheelEvt();
  //     if (state.isMenu){
  //       if (state.whaleSceneCurrentID==0){
  //         wheel.mouseWheelEvt();
  //       }
  //       else {
  //         whaleSceneSet.whaleTypeTrans=true;
  //         state.whaleSceneCurrentID=Math.max(state.whaleSceneCurrentID-1, 0);
  //         whalehandle.prev();
  //         whalehandle.currentHandle(state.whaleSceneCurrentID);
  //       }
  //     }
  //   }
  // },
  // next: () => {
  //   whaleSceneSet.fadeTl.to(
  //     whaleSceneSet.whaleDom[state.whaleSceneCurrentID-1],
  //     .2, { opacity:0 }
  //   )
  //   .to(
  //     whaleSceneSet.whaleDom[state.whaleSceneCurrentID],
  //     .8, { opacity:1, onComplete:()=>{
  //       setTimeout(()=>{
  //         whaleSceneSet.whaleTypeTrans=false;
  //         whalehandle.mouseWheelEvt();
  //       }, whaleSceneSet.interval);
  //     }
  //   });
  // },
  // prev: () => {
  //   whaleSceneSet.fadeTl.to(
  //     whaleSceneSet.whaleDom[state.whaleSceneCurrentID+1],
  //     .2, { opacity:0 }
  //   )
  //   .to(
  //     whaleSceneSet.whaleDom[state.whaleSceneCurrentID],
  //     .8, { opacity:1, onComplete:()=>{
  //       setTimeout(()=>{
  //         whaleSceneSet.whaleTypeTrans=false;
  //         whalehandle.mouseWheelEvt();
  //       }, whaleSceneSet.interval);
  //     }
  //   });
  // },
  onClickToNextWhale:(id) =>{
    whaleSceneSet.fadeTl.to(
      whaleSceneSet.whaleDom[state.whaleSceneCurrentID],
      .3, { opacity:0 }
    )
    .to(
      whaleSceneSet.whaleDom[id],
      .8, { opacity:1, onComplete:()=>{
        setTimeout(()=>{
          state.whaleSceneCurrentID=id;
          whaleSceneSet.whaleTypeTrans=false;
          // whalehandle.mouseWheelEvt();
        }, whaleSceneSet.interval);
      }
    });
  },
  currentHandle:(id) =>{
    // タブメニュー
    whaleSceneSet.whaleType.removeClass(whaleSceneSet.active);
    whaleSceneSet.whaleType.eq(id).addClass(whaleSceneSet.active);
    // クジラ切り替え
    whaleSceneSet.whaleItem.removeClass(whaleSceneSet.active);
    whaleSceneSet.whaleItem.eq(id).addClass(whaleSceneSet.active);
    // 測り切り替え
    whaleSceneSet.whaleScale.removeClass(whaleSceneSet.active);
    whaleSceneSet.whaleScale.eq(id).addClass(whaleSceneSet.active);

    $('#w-whaleLength').removeClass().addClass("is-"+id);

    // 目盛りカウント
    whalehandle.counter(id);
  },
  counter: (idx)=> {
    let count=0;
    let countup = function(){
      count += 1;
      $('#w-whaleLength .w-whaleLengthText .w-whaleLengthTextNumber').html(Math.min(count, whaleSceneSet.measure[0][idx]));
    }

    let id = setInterval(function(){
      countup();
      if(count > whaleSceneSet.measure[0][idx]){　
        clearInterval(id);
      }
    }, 60);
  },
  onClick:() =>{
    whaleSceneSet.whaleType.on(
      'click',
      (e)=>{
        let id=e.currentTarget.getAttribute('data-typeid');
        if (whaleSceneSet.whaleTypeTrans==false
          && state.isMenu==true
          && state.whaleSceneCurrentID != id) {
          whaleSceneSet.whaleTypeTrans=true;
          // whalehandle.noMouseWheelEvt();
          whalehandle.onClickToNextWhale(id);
          whalehandle.currentHandle(id);
        }
      }
    );
  },
  onClickPager:()=>{
    $('.w-next').on(
      'click',
      (e) =>{
        if (whaleSceneSet.whaleTypeTrans==false && state.isMenu==true) {
          whaleSceneSet.whaleTypeTrans=true;
          let id=(state.whaleSceneCurrentID==2) ? 0 : Math.min(state.whaleSceneCurrentID+1, 2);
          whalehandle.onClickToNextWhaleNoScroll(id);
          whalehandle.currentHandle(id);
        }
        
      }
    );
    $('.w-prev').on(
      'click',
      (e) =>{
        if (whaleSceneSet.whaleTypeTrans==false && state.isMenu==true) {
          whaleSceneSet.whaleTypeTrans=true;
          let id=(state.whaleSceneCurrentID==0) ? 2 : Math.max(state.whaleSceneCurrentID-1, 0);
          whalehandle.onClickToNextWhaleNoScroll(id);
          whalehandle.currentHandle(id);
        }
      }
    );
  },
  onClickNoScroll:()=>{
    whaleSceneSet.whaleType.on(
      'click',
      (e)=>{
        if (whaleSceneSet.whaleTypeTrans==false && state.isMenu==true) {
          whaleSceneSet.whaleTypeTrans=true;
          let id=e.currentTarget.getAttribute('data-typeid');
          whalehandle.onClickToNextWhaleNoScroll(id);
          whalehandle.currentHandle(id);
        }
      }
    );
  },
  onClickToNextWhaleNoScroll:(id)=>{
    whaleSceneSet.fadeTl.to(
      whaleSceneSet.whaleDom[state.whaleSceneCurrentID],
      .3, { opacity:0 }
    )
    .to(
      whaleSceneSet.whaleDom[id],
      .8, { opacity:1, onComplete:()=>{
        setTimeout(()=>{
          state.whaleSceneCurrentID=id;
          whaleSceneSet.whaleTypeTrans=false;
        }, whaleSceneSet.interval);
      }
    });
  },
};